module.exports = __webpack_public_path__ + "8424ed6e79e837cfa29d45df84db39d1.jpg";